<template>
    <article class="bg-gray-50 rounded-lg shadow-sm" :aria-labelledby="headlineId">
        <div
            class="p-2 grid grid-cols-[[link]_auto_[single]_max-content_[status]_minmax(80px,max-content)_[end]] grid-flow-col items-center gap-12"
        >
            <div class="col-[link] text-sm text-gray-900 flex justify-between font-bold">
                <TextLink :id="headlineId" :to="linkTarget">
                    {{ linkText }}
                </TextLink>
            </div>
            <Tooltip v-if="isSingleEvent" class="col-[single]">
                <template #trigger="tooltipProps">
                    <SingleEventIcon
                        v-bind="tooltipProps"
                        class="inline w-5 h-5 text-gray-700 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-gray-700 focus-visible:ring-offset-2 rounded-xs"
                        tabindex="0"
                    />
                </template>
                <template #text>{{ $t('limited-to-single-event') }}</template>
            </Tooltip>
            <div v-else class="col-[single]"></div>
            <Badge
                class="col-[status] justify-self-end"
                size="Extra-Small"
                :variant="eventSeriesStatusToBadgeVariant(series.status as EventSeriesStatus)"
            >
                {{ getEventSeriesStatusLabel(series.status) }}
            </Badge>
        </div>
    </article>
</template>

<script setup lang="ts">
import Badge from '@/components/Badge/Badge.vue';
import SingleEventIcon from '@/components/Icon/SingleEventIcon.vue';
import TextLink from '@/components/TextLink/TextLink.vue';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import { nanoid } from 'nanoid';
import { RouteLocationRaw } from 'vue-router';
import { eventSeriesStatusToBadgeVariant, getEventSeriesStatusLabel } from '../event';
import { EventSeriesStatus } from '../types';

type EventSeriesCardProps = {
    series: {
        id: string;
        nameShort: string;
        status: string;
    };
    linkTarget: RouteLocationRaw;
    linkText: string;
    isSingleEvent: boolean;
    helpText?: string;
    hasBorderBottom?: boolean;
};

defineProps<EventSeriesCardProps>();
const headlineId = nanoid();
</script>
